(function () {
  document.addEventListener("theme:resize", () => {});

  document.addEventListener("theme:variant:change", (e) => {
    const variantId = e.detail.variant.id;

    if (!window.theme.settings.image_filteration) return;

    if (window.innerWidth < 768) {
      document
        .querySelectorAll(".product-single-media-slider[data-variant-id]")
        .forEach((itm) => itm.classList.add("hiddenn"));

      const variantCarouselContainer = document.querySelector(
        `.product-single-media-slider[data-variant-id='${variantId}']`,
      );

      variantCarouselContainer.classList.remove("hiddenn");

      const mainCarousel =
        variantCarouselContainer.querySelector(".carousel-main");

      const navCarousel =
        variantCarouselContainer.querySelector(".carousel-nav");

      const mainFlickity = new themeVendor.Flickity(
        mainCarousel,
        JSON.parse(mainCarousel.dataset.flickity),
      );

      const navFlickity = new themeVendor.Flickity(
        navCarousel,
        JSON.parse(navCarousel.dataset.flickity),
      );

      mainFlickity.resize();

      setTimeout(() => {
        navFlickity.resize();
      }, 100);
    } else {
      document
        .querySelectorAll(`.product-single__media-slider`)
        .forEach((itm) => itm.classList.add("hidden"));

      document
        .querySelector(`.product-single__media-slider--${variantId}`)
        .classList.remove("hidden");
      // document
      //   .querySelectorAll(`.product-single__gallery [data-product-slide]`)
      //   .forEach((image) => {
      //     image.classList.remove("hidden");
      //     image.removeAttribute("data-index");
      //   });

      // document.querySelectorAll(
      //   `[data-product-slide]:not([data-variant-id='${variantId}'])`
      // ).forEach((image) => image.classList.add("hidden"));

      // document
      //   .querySelectorAll(
      //     `.product-single__gallery [data-product-slide][data-variant-id='${variantId}']`
      //   )
      //   .forEach((image, index) => {
      //     image.dataset.index = index + 1;
      //   });
    }
  });

  document.addEventListener("theme:variant:change", (e) => {
    const selectors = {
      radioLabel: ".radio__legend__value",
    };

    const variant = e.detail.variant;

    const radioLabels = document.querySelectorAll(selectors.radioLabel);

    if (radioLabels.length == 0) return;

    radioLabels.forEach((radioLabel) => (radioLabel.innerHTML = variant.title));
  });

  document.addEventListener("theme:variant:change", (e) => {
    const variantMetafields = JSON.parse(
      document.querySelector("#VariantMetafields").innerHTML,
    );

    const variantId = e.detail.variant.id;

    const variantMetafield = variantMetafields[variantId];

    if (!variantMetafield) return;

    const showShippingTime = variantMetafield.showShippingTime;

    const newMetafieldRow = document.querySelector(
      ".product__icon__row--new-metafield",
    );
    const oldMetafieldRow = document.querySelector(
      ".product__icon__row--old-metafield",
    );

    if (newMetafieldRow) {
      newMetafieldRow.style.display = showShippingTime ? "flex" : "none";
    }

    if (oldMetafieldRow) {
      oldMetafieldRow.style.display = !showShippingTime ? "flex" : "none";
    }
  });
})();

class LimitedText extends HTMLElement {
  constructor() {
    super();
    // this.classList.add("limited-text");
    const readMore = this.querySelector("read-more");
    readMore.addEventListener("click", () => {
      console.log(this);
      this.classList.remove("limited-text");
    });
  }
}

customElements.define("limited-text", LimitedText);

(function () {
  const selectors = {
    collectionListSwiper: ".collection-list-scroller",
  };

  const collectionListSwiper = document.querySelector(
    selectors.collectionListSwiper,
  );

  if (!collectionListSwiper) return;

  const init = () => {
    new themeVendor.Flickity(collectionListSwiper, {
      cellAlign: "left",
      contain: true,
      pageDots: false,
      wrapAround: false,
      prevNextButtons: false,
      freeScroll: true,
    });
  };

  init();

  console.log("---------");

  document.addEventListener("shopify:section:load", (e) => {
    console.log(e);
    console.log("---------");
    init();
  });
  document.addEventListener("shopify:section:reorder", (e) => {
    console.log("---------");
    console.log(e);
    init();
  });
  document.addEventListener("shopify:section:select", (e) => {
    console.log("---------");
    console.log(e);
    init();
  });
})();

class CollectionRowChanger extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll("button");
    this.productsGrid = this.closest(".collection").querySelector(
      ".collection__products .grid",
    );

    this.buttons.forEach((button) => {
      button.addEventListener("click", () => {
        const row = parseFloat(button.dataset.perRow);
        if (!row) return;
        const propertyValue = row == 1 || row == 2 ? "--grid-mobile" : "--grid";
        this.productsGrid.style.setProperty(
          propertyValue,
          `repeat(${row}, minmax(0, 1fr))`,
        );

        if (row == 1) {
          this.productsGrid.style.setProperty(
            "grid-auto-columns",
            "min-content",
          );
        } else {
          this.productsGrid.style.removeProperty("grid-auto-columns");
        }

        if (window.innerWidth < 768) {
          this.buttons.forEach((button) =>
            button.classList.remove("active--mobile"),
          );
          button.classList.add("active--mobile");
        }
        if (window.innerWidth > 768) {
          this.buttons.forEach((button) =>
            button.classList.remove("active--desktop"),
          );
          button.classList.add("active--desktop");
        }
      });
    });
  }
}

customElements.define("collection-row-changer", CollectionRowChanger);

document.addEventListener("theme:cart:add", (event) => {
  console.log(event);

  setTimeout(() => {
    fetch(`${window.theme.routes.cart_url}.js`)
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        try {
          document
            .querySelectorAll("[data-cart-count]")
            .forEach((itm) => (itm.innerText = ` (${data.item_count})`));
        } catch (error) {
          console.log(error);
        }
      });
  }, 600);
});
